import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "category-tree" };
const _hoisted_2 = { class: "category-tree__list" };
const _hoisted_3 = { class: "category-tree__home" };
import CategoryTreeNode from "../components/CategoryTreeNode.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryTree',
    props: {
        categories: {},
        activeCategory: {}
    },
    emits: ['selectCategory'],
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("ul", _hoisted_2, [
                    _createElementVNode("li", _hoisted_3, [
                        _createVNode(_component_RouterLink, {
                            to: { name: 'catalog_category' },
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('selectCategory', null)))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('catalog.all_categories')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.categories, (category) => {
                        return (_openBlock(), _createBlock(CategoryTreeNode, {
                            key: category.code,
                            category: category,
                            "active-category": __props.activeCategory,
                            level: 0,
                            onSelect: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('selectCategory', $event)))
                        }, null, 8, ["category", "active-category"]));
                    }), 128))
                ])
            ]));
        };
    }
});
